<template>
    <el-drawer
        :append-to-body="true"
        :before-close="cancel"
        :title="title"
        :visible.sync="dialogVisible"
        width="500px">
        <div class="flex flex-direction padding-lr-sm">
            <div class="self-center text-gray" v-if="time">保存时间：{{time}}</div>
            <div class="detail margin-top-sm" v-html="content"></div>
        </div>
    </el-drawer>
</template>

<script>


export default {
    name: "TemplateDetailDialog",
    components: {},
    data() {
        return {
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        time: {
            type: String,
            default: ''
        }
    },
    computed: {

    },
    created() {

    },
    methods: {
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {

    }
}
</script>

<style lang="scss" scoped>

.template-item {
    width: 100%;
    border: 1px solid #eeeeee;

    .operate {
        border-top: 1px solid #eeeeee;
        height: 50px;
    }
}

</style>